import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { PlatformTransactionKey } from 'api/Trading-Accounts/Types/PlatformTransactionDto'
import { HeaderSortCell } from 'components/Filter'
import { formatUTCDate } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const tradingAccountPlatformTransactionDetailsColumn: GridColumn[] = [
  {
    title: 'Ticket',
    field: PlatformTransactionKey.ticket,
    show: true,
    filterable: true,
    sortable: false,
    width: 100,
    className: 'trading-account-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Symbol',
    field: PlatformTransactionKey.symbol,
    show: true,
    filterable: true,
    sortable: false,
    width: 100,
    className: 'trading-account-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Type',
    field: `${PlatformTransactionKey.type}.name`,
    show: true,
    filterable: true,
    sortable: false,
    width: 80,
    className: 'trading-account-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Platform',
    field: `${PlatformTransactionKey.platform}.name`,
    show: true,
    filterable: true,
    sortable: false,
    width: 80,
    className: 'trading-account-table-columns__content',
    filter: 'text',
  },
  {
    title: 'Time',
    show: true,
    field: 'time',
    children: [
      {
        title: 'Open',
        field: PlatformTransactionKey.openTime,
        headerCell: HeaderSortCell,
        filterable: true,
        sortable: true,
        cell: (props: GridCellProps): JSX.Element => {
          return (
            <td className='clients-table-columns__date'>
              {formatUTCDate(props.dataItem.openTime, true)}
            </td>
          )
        },
        width: 100,
        filter: 'text',
      },
      {
        title: 'Close',
        field: PlatformTransactionKey.closeTime,
        headerCell: HeaderSortCell,
        filterable: true,
        sortable: true,
        cell: (props: GridCellProps): JSX.Element => {
          return (
            <td className='clients-table-columns__date'>
              {formatUTCDate(props.dataItem.closeTime, true)}
            </td>
          )
        },
        width: 100,
        filter: 'text',
      },
    ],
  },
  {
    title: 'Volume',
    field: PlatformTransactionKey.volume,
    show: true,
    filterable: true,
    sortable: false,
    width: 75,
    className: 'trading-account-table-columns__number',
    filter: 'text',
  },
  {
    title: 'Price',
    show: true,
    field: 'price',
    children: [
      {
        title: 'Open',
        field: PlatformTransactionKey.openPrice,
        filterable: true,
        sortable: false,
        width: 90,
        className: 'trading-account-table-columns__number',
        filter: 'text',
      },
      {
        title: 'Close',
        field: PlatformTransactionKey.closePrice,
        filterable: true,
        sortable: false,
        width: 90,
        className: 'trading-account-table-columns__number',
        filter: 'text',
      },
      {
        title: 'Stop Loss',
        field: PlatformTransactionKey.stopLoss,
        filterable: true,
        sortable: false,
        width: 90,
        className: 'trading-account-table-columns__number',
        filter: 'text',
      },
      {
        title: 'Take Profit',
        field: PlatformTransactionKey.takeProfit,
        filterable: true,
        sortable: false,
        width: 90,
        className: 'trading-account-table-columns__number',
        filter: 'text',
      },
    ],
  },
  {
    title: 'Profit',
    field: PlatformTransactionKey.profit,
    show: true,
    filterable: true,
    sortable: false,
    width: 90,
    className: 'trading-account-table-columns__number',
    filter: 'text',
  },
  {
    title: 'Commission',
    field: PlatformTransactionKey.commission,
    show: true,
    filterable: true,
    sortable: false,
    width: 110,
    className: 'trading-account-table-columns__number',
    filter: 'text',
  },
  {
    title: 'Swaps',
    field: PlatformTransactionKey.swaps,
    show: true,
    filterable: true,
    sortable: false,
    width: 90,
    className: 'trading-account-table-columns__number',
    filter: 'text',
  },
  {
    title: 'Comment',
    field: PlatformTransactionKey.comment,
    show: true,
    filterable: true,
    sortable: false,
    width: 250,
    className: 'trading-account-table-columns__content',
    filter: 'text',
  },
]

export default tradingAccountPlatformTransactionDetailsColumn
